import {
    AttributeNameValuesPair,
    AttributesFilterInput,
    LocalesEnum,
    OperationsEnum,
} from 'src/generated/operations';

export type QueryParamName = string;
export type ProductAttributeId = string;
export type FilterConfig = Array<[QueryParamName, ProductAttributeId]>;
export type Filter = Record<QueryParamName, string[]>;
export type MandatoryFilterConfig = {
    config: FilterConfig;
    values: Filter;
}

export const NULL_STRING = 'NULL';
export const LABEL_FIELD_NAME = 'label';

const SKIP_STRINGIFY = [
    LABEL_FIELD_NAME,
];

export function composeFilter(
    config: FilterConfig | null,
    filter: Filter,
    locale: LocalesEnum,
    namesForAndOp: string[] = [],
): AttributesFilterInput {
    if (config == null) {
        return {
            values: [],
        };
    }
    const getFilterValue = (field: string): string[] => (filter[field] || []).filter((v) => !!v);
    return {
        values: [] as AttributeNameValuesPair[],
        and: config
            .map((items) => {
                const [field, name] = items as [string, string];
                const op = namesForAndOp.includes(field) ? 'and' : 'or';
                const values = getFilterValue(field);
                const inner: AttributesFilterInput = {
                    values: [] as AttributeNameValuesPair[],
                    [op]: values.map((value) => {
                        if (value === NULL_STRING) {
                            return { values: [{ name, locale, values: null, op: OperationsEnum.Eq }] };
                        }
                        return {
                            values: [{
                                name,
                                locale,
                                values: [`%%${SKIP_STRINGIFY.includes(name) ? value : JSON.stringify(value)}%%`],
                                op: OperationsEnum.Like,
                            }],
                        };
                    }),
                };
                return (inner.or || []).length > 0 || (inner.and || []).length > 0 ? inner : null;
            })
            .filter((item) => item !== null),
    // @TODO remove typecast
    } as AttributesFilterInput;
}
